import { Box, MenuItem, Stack, TextField, Typography } from '@mui/material';
import { CanvasFieldData } from '../hooks/useProcessModuleCanvas';

interface ExistingCanvasSelectorProps {
  currentCanvasId: string;
  existingFields: CanvasFieldData[];
  isSubmitting: boolean;
  onCanvasSelect: (canvasId: string) => void;
}

export const ExistingCanvasSelector = ({
  currentCanvasId,
  existingFields,
  isSubmitting,
  onCanvasSelect,
}: ExistingCanvasSelectorProps) => {
  return (
    <Stack spacing={2}>
      <Typography variant="subtitle2" color="text.secondary">
        Select from available canvases in this process module:
      </Typography>

      <TextField
        select
        fullWidth
        label="Select Canvas"
        value={currentCanvasId}
        onChange={(e) => onCanvasSelect(e.target.value)}
        disabled={isSubmitting}
        helperText={existingFields.length === 0 ? 'No existing canvases available' : 'Choose a canvas to reuse'}
      >
        <MenuItem value="" disabled>
          <em>Select a canvas...</em>
        </MenuItem>
        {existingFields.map((canvas) => (
          <MenuItem key={canvas.canvasId} value={canvas.canvasId}>
            <Box>
              <Typography variant="body1">{canvas.fieldLabel}</Typography>
              <Typography variant="caption" color="text.secondary">
                From form: {canvas.formName}
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </TextField>
    </Stack>
  );
};
